
export class SubjectAreaFilterOptions {
    subjectAreaIds: Array<number>;
}
